module.exports = __webpack_public_path__ + "static/oghma-symbol-SCAG-815236828b83c4f1a3f3f6648f21fa0e.png";